import React from 'react';
import PropTypes from 'prop-types';
import { FolderAdd } from '@styled-icons/remix-line';

import * as S from './styles';

const ButtonNew = ({ propLink, propText, propClickAction }) => {
  return (
    <S.Link onClick={propClickAction} to={propLink}>
      <S.IconWrapper>
        <FolderAdd />
      </S.IconWrapper>
      {propText}
    </S.Link>
  );
};

ButtonNew.defaultProps = {
  propLink: '#',
  propText: '',
  propClickAction: () => {},
};

ButtonNew.propTypes = {
    propLink: PropTypes.string,
    propText: PropTypes.string,
    propClickAction: PropTypes.func,
};

export default ButtonNew;
